// MAIN
import { createApp } from 'vue'
import store from './store'
//import router from './router'

// PLUGINS
import Toast from "vue-toastification";
import VCalendar from 'v-calendar'
import VueAwesomePaginate from "vue-awesome-paginate";
// Aside
import initGoodSlider from "@/aside/goodsSlider.js"
import initMobileMenu from "@/aside/mobileMenu.js"

// STYLES
import 'v-calendar/dist/style.css'
import '@/assets/styles/main.sass'


// COMPONENTS
import PageTitle from "@/components/blocks/PageTitle.vue";
import RequestBtn from "@/components/base/header/RequestBtn.vue";
import AuthBtn from "@/components/base/header/AuthBtn.vue";
import CurrentTime from "@/components/base/header/CurrentTime.vue";
import UserInfo from "@/components/base/header/UserInfo.vue";
import ChangePassword from "@/components/forms/ChangePassword.vue";

// ADMIN
import AdminMain from "@/components/sections/AdminMain.vue";
import AdminInner from "@/components/sections/AdminInner.vue";

import TendersPage from "@/components/sections/Tenders/TenderPage/TendersPage.vue";
import TenderInner from "@/components/sections/Tenders/TenderInner/TenderInner.vue";
import CreateEditTender from "@/components/sections/Tenders/CreateEditTender/CreateTender.vue";

import ManagersPage from "@/components/sections/Managers/ManagersPage.vue";
import ManagersAdd from "@/components/sections/Managers/ManagersAdd.vue";
import CategoryManagersPage from "@/components/sections/CategoryManagers/CategoryManagersPage.vue";
import CategoryManagerAdd from "@/components/sections/CategoryManagers/CategoryManagerAdd.vue";
import CategoryAdminsPage from "@/components/sections/CategoryAdmins/CategoryAdminsPage.vue";
import CategoryAdminAdd from "@/components/sections/CategoryAdmins/CategoryAdminAdd.vue";
import StoreGroupsPage from "@/components/sections/Store/StoreGroupsPage.vue";
import StoreAdd from "@/components/sections/Store/StoreAdd.vue";
import SuppliersPage from "@/components/sections/Suppliers/SuppliersPage.vue";
import BlackListPage from "@/components/sections/BlackList/BlackListPage.vue";
import SchedulesPage from "@/components/sections/Schedules/SchedulesPage.vue";
import CreateSchedule from "@/components/sections/Schedules/CreateEditSchedule/CreateSchedule.vue";

// SUPPLY
import LcSupplyPage from "@/components/sections/LcSupply/LcSupplyPage.vue";
import SupplierPage from "@/components/sections/LcSupply/SupplierCard/SupplierPage.vue";

// Stats
import StatsPage from "@/components/sections/Stats/StatsPage.vue";
import StatsUpload from "@/components/sections/Stats/StatsUpload.vue";
// Notices
import NotificationsPage from "@/components/sections/Notifications/NotificationsPage.vue";

// Contacts
import ContactsMap from "@/components/sections/Contacts/ContactsMap.vue";
import ContactsRoute from "@/components/sections/Contacts/ContactsRoute.vue";

// Forms
import ContactsFeedback from "@/components/forms/ContactsFeedback.vue";
import AuthLoginPopup from "@/components/forms/AuthLoginPopup.vue";



const vueObject = {
	components: {
		PageTitle,
		CurrentTime,
		RequestBtn,
		AuthBtn,
		UserInfo,
		ChangePassword,
		AuthLoginPopup,
		VueAwesomePaginate,
		AdminMain,
		AdminInner,
		TendersPage,
		TenderInner,
		CreateEditTender,
		ManagersPage,
		ManagersAdd,
		CategoryManagersPage,
		CategoryManagerAdd,
		CategoryAdminsPage,
		CategoryAdminAdd,
		StoreGroupsPage,
		StoreAdd,
		SuppliersPage,
		BlackListPage,
		LcSupplyPage,
		ContactsMap,
		ContactsRoute,
		ContactsFeedback,
		StatsPage,
		NotificationsPage,
		StatsUpload,
		SupplierPage,
		SchedulesPage,
		CreateSchedule
	},
	mounted() {
		const el = document.body;
		const observer = new MutationObserver(() => {
			if (el.querySelector('.popup')) {
				document.body.classList.add('popup-opened');
			} else {
				document.body.classList.remove('popup-opened');
			}
		});
		observer.observe(el, {subtree: true, childList: true});
	},
}
const app = createApp(vueObject);

app.directive('hidden-text', {
	mounted(el, binding) {
		const maxHeightBlock = el.scrollHeight
		if(maxHeightBlock > binding.value.height) {
			const div = document.createElement('div')
			const span = document.createElement('span')
			div.classList.add('hidden-text')
			div.setAttribute('data-title', binding.value.title)
			div.style = `--max-height: ${binding.value.height}px;`
			span.textContent = el.textContent
			el.textContent = ''
			div.appendChild(span)
			el.appendChild(div)

			div.addEventListener('click', () => {
				div.style = `--max-height: ${maxHeightBlock}px;`
				div.classList.add('open')
			})
		}
	}
});

app.use(store)
	.use(Toast, { containerClassName: 'notificator' })
	.use(VCalendar)
	.use(VueAwesomePaginate)
	.mount('#app');
	
window.addEventListener("load", () => {
	initGoodSlider()
	initMobileMenu()
})

